import React, { useState, useEffect } from "react";
import Aeroplane from "../Assets/new Landing/airplane.png"; // Ensure the path is correct
import Brain from "../Assets/new Landing/brain.png"; // Ensure the path is correct

const JobRoles = () => {
  // All job roles data
  const jobRoles = [
    // First Group
    { title: "Software Developer", jobs: "19K+" },
    { title: "App Developer", jobs: "2.5K+" },
    { title: "Front End Developer", jobs: "3.5K+" },
    { title: "DevOps Engineer", jobs: "2.2K+" },
    { title: "Full Stack Developer", jobs: "1.3K+" },
    { title: "Mobile Developer", jobs: "10.5K+" },

    // Second Group
    { title: "Test Engineer", jobs: "2K+" },
    { title: "Analyst", jobs: "1K+" },
    { title: "Architect", jobs: "4.3K+" },
    { title: "Business Analyst", jobs: "4K+" },
    { title: "Data Scientist", jobs: "800+" },
    { title: "Program Manager", jobs: "500+" },

    // Third Group
    { title: "Product Manager", jobs: "1K+" },
    { title: "UI / UX Designer", jobs: "1.8K+" },
    { title: "Research Analyst", jobs: "500+" },
    { title: "Manager", jobs: "400+" },
    { title: "Consultant", jobs: "3.5K+" },
    { title: "Chartered Accountant", jobs: "700+" },
  ];

  // State to manage the current page
  const [currentPage, setCurrentPage] = useState(0);

  // Number of roles per page
  const rolesPerPage = 6;

  // Calculate total number of pages
  const totalPages = Math.ceil(jobRoles.length / rolesPerPage);

  // Function to get the roles for the current page
  const getCurrentPageRoles = () => {
    const start = currentPage * rolesPerPage;
    const end = start + rolesPerPage;
    return jobRoles.slice(start, end);
  };

  // Function to go to the next page
  const nextPage = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
  };

  // Function to go to the previous page
  const previousPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === 0 ? totalPages - 1 : prevPage - 1,
    );
  };

  // Automatically change pages every 10 seconds
  useEffect(() => {
    const interval = setInterval(nextPage, 10000);
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  return (
    <div className="flex flex-col md:flex-row items-center justify-between bg-background mt-2 p-12  shadow-md relative">
      {/* Left Section */}
      <div className="flex-1">
        <div className="flex items-center">
          {/* Replace F with Aeroplane image, add margin-left */}
          <div className="w-40 h-40 bg-logos rounded-full flex items-center justify-center ml-6 shadow-[inset_4px_4px_10px_rgba(0,0,0,0.7)] ">
          <img
              src={Brain}
              alt="Aeroplane"
              className="w-20 h-20 object-contain"
            />
            <img
              src={Aeroplane }
              alt="Aeroplane"
              className="w-20 h-20 object-contain"
            />

          </div>
        </div>
        <h2 className="text-2xl font-bold text-textWhite font-josefin mt-4">
          Explore job opportunities in various fields
        </h2>
        <p className="text-textWhite font-josefin mt-2">
          Tell us your career goal, we'll find the perfect job
        </p>
      </div>

      {/* Right Section */}
      <div className="flex-1 mt-6 md:mt-0 md:ml-6 relative">
        {/* Job Roles */}
        <div className="grid grid-cols-2 gap-4">
          {getCurrentPageRoles().map((role, index) => (
            <div
              key={index}
              className="p-4 bg-boxes border border-boxes rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <h3 className="text-lg font-medium text-textWhite">
                {role.title}
              </h3>
              <p className="text-sm text-textWhite">{role.jobs} Jobs</p>
            </div>
          ))}
        </div>

        {/* Pagination Controls (Bottom) */}
        <div className="flex items-center justify-between mt-6">
          {/* Backward Button */}
          <button
            onClick={previousPage}
            className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 shadow"
          >
            ◄
          </button>

          {/* Pagination Dots */}
          <div className="flex space-x-2">
            {Array.from({ length: totalPages }).map((_, index) => (
              <div
                key={index}
                className={`w-2 h-2 rounded-full ${
                  index === currentPage ? "bg-logos" : "bg-gray-300"
                }`}
              ></div>
            ))}
          </div>

          {/* Forward Button */}
          <button
            onClick={nextPage}
            className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 shadow"
          >
            ►
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobRoles;
